import Flex from '@eversports/react-components/primitives/Flex'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import { useLocation } from 'react-router-dom'

import useCheckoutContext from '../../data/useCheckoutContext'
import getPhoenixUrlParams from '../../lib/get-phoenix-url-params'
import { PriceTableItem } from '../../typings/PriceTable'
import CorporateBudgetItem from './CorporateBudgetItem'

import MembershipPriceSummaryItem from './MembershipPriceSummaryItem'
import SpecialPriceSummaryItem from './SpecialPriceSummaryItem'

const useStyles = makeStyles({
  item: {
    maxWidth: 'fit-content',
    wordBreak: 'break-word',
  },
})

interface Props {
  item: PriceTableItem
}

const SummaryItem = ({ item }: Props) => {
  const context = useCheckoutContext()
  const classes = useStyles()
  const location = useLocation()

  const { orderId } = getPhoenixUrlParams(location.search)

  switch (item.__typename) {
    case 'PriceTableItemMembership':
      return <MembershipPriceSummaryItem membership={item} />
    case 'PriceTableItemVoucher':
      return (
        <Flex justifyContent="space-between">
          <div>
            <Flex horizontalSpacing="dense" alignItems="center">
              <Text>{item.name}</Text>
              {!orderId && (
                <Icon
                  icon={Icons.REMOVE_CIRCLE}
                  color="primary.main"
                  onClick={() => context.onVoucherRemoval({ code: item.code })}
                />
              )}
            </Flex>
            <Text size="x-small">{item.code}</Text>
          </div>
          <Text fontWeight="bold">
            {item.totalPrice && <MonetaryValue value={item.totalPrice.value} currencyCode={item.totalPrice.currency} />}
          </Text>
        </Flex>
      )
    case 'PriceTableItemSpecialPrice':
      return <SpecialPriceSummaryItem item={item} />
    case 'PriceTableItemBudget':
      return <CorporateBudgetItem item={item} />

    case 'PriceTableItemAddon':
      return (
        <Flex className={classes.item}>
          <Text size="small">
            {item.amount > 1 && `${item.amount}x `}
            {item.name}
          </Text>
        </Flex>
      )
    case 'PriceTableItemBasic':
    default:
      return (
        <Flex justifyContent="space-between" alignItems="center" horizontalSpacing="dense">
          <Flex className={classes.item}>
            <Text marginRight="dense">
              {item.amount > 1 && `${item.amount}x `}
              {item.name}
            </Text>
          </Flex>
          <Text fontWeight="bold" marginLeft="dense">
            {item.totalPrice && <MonetaryValue value={item.totalPrice.value} currencyCode={item.totalPrice.currency} />}
          </Text>
        </Flex>
      )
  }
}

export default SummaryItem
